import React from 'react';
import { To } from 'react-router-dom';

export type Key = string | number;

export type InternalProps = {
  as?: React.FC;
  className?: string;
  onClick?: () => void;
};

export type MenuData = {
  key: Key;
  to?: To;
  content?: React.ReactNode;
  className?: string;
  children?: MenuData[];
  completed?: boolean;
  type?: Model.Class['type'];
} & Record<string, any>;

export type CallbackArgs = {
  activeKeys: Key[];
  openKeys: Key[];
  itemKey: Key;
  subMenuKey: Key;
};

export type MenuProps = {
  className?: string;
  activeKeys?: Key[];
  openKeys?: Key[];
  onChange?: (args: CallbackArgs) => void;
  itemProps?: InternalProps;
  subMenuProps?: InternalProps;
  menu?: MenuData[];
};

export const MenuContext = React.createContext<MenuProps>({
  activeKeys: [],
  openKeys: [],
});

export const useMenuContext = () => React.useContext(MenuContext);
